module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'vu2xsthp',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
